import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_tax_txn_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    line_num: fromDatatype.NumericDatatypeInterface;
    tax_filing_date: fromDatatype.TimestampTzDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_line_guid: fromDatatype.GuidDataFieldInterface;
    enitity_type: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.TextDatatypeInterface;
    entity_comp_registration_num: fromDatatype.VarcharDatatypeInterface;
    entity_address: fromDatatype.TextDatatypeInterface;
    doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    doc_hdr_doc_type: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_num_comp: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_num_branch: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_amount_signum: fromDatatype.NumericDatatypeInterface;
    doc_hdr_amount_txn: fromDatatype.NumericDatatypeInterface; 
    doc_hdr_amount_net: fromDatatype.NumericDatatypeInterface;
    doc_hdr_amount_tax: fromDatatype.NumericDatatypeInterface;
    doc_hdr_amount_wht: fromDatatype.NumericDatatypeInterface;
    doc_hdr_tax_converted_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_hdr_tax_converted_by: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_self_bill_appr_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_hdr_self_bill_serial_num: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    doc_line_guid: fromDatatype.GuidDataFieldInterface;
    doc_line_item_code: fromDatatype.VarcharDatatypeInterface;
    doc_line_item_desc: fromDatatype.GuidDataFieldInterface;
    doc_line_item_remarks: fromDatatype.TextDatatypeInterface;
    doc_line_item_qty: fromDatatype.NumericDatatypeInterface;
    doc_line_tax_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_line_tax_type: fromDatatype.VarcharDatatypeInterface;
    doc_line_tax_code: fromDatatype.VarcharDatatypeInterface;
    doc_line_tax_rate: fromDatatype.NumericDatatypeInterface;
    doc_line_tax_balance: fromDatatype.NumericDatatypeInterface;
    doc_line_wht_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_line_wht_type: fromDatatype.VarcharDatatypeInterface;
    doc_line_wht_code: fromDatatype.VarcharDatatypeInterface;
    doc_line_wht_rate: fromDatatype.NumericDatatypeInterface;
    doc_line_wht_amount: fromDatatype.NumericDatatypeInterface;
    doc_line_wht_balance: fromDatatype.NumericDatatypeInterface;
    doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
    doc_line_amount_txn: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_net: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_tax: fromDatatype.NumericDatatypeInterface;
    doc_line_ccy_2: fromDatatype.VarcharDatatypeInterface;
    doc_line_amount_txn_2: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_net_2: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_tax_2: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_wht_2: fromDatatype.NumericDatatypeInterface;
    doc_line_irr: fromDatatype.NumericDatatypeInterface;
    doc_line_permit_no: fromDatatype.VarcharDatatypeInterface;
    doc_line_major_industry_code: fromDatatype.VarcharDatatypeInterface;
    doc_line_property_json: fromDatatype.JsonDatatypeInterface;
    ext_property_json: fromDatatype.JsonDatatypeInterface;
    process_json: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    doc_hdr_client_doc: fromDatatype.VarcharDatatypeInterface;
    entity_tax_id: fromDatatype.VarcharDatatypeInterface;
    doc_event_guid: fromDatatype.GuidDataFieldInterface;
    doc_hdr_client_doc_type: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    filing_hdr_guid: fromDatatype.GuidDataFieldInterface;
    tax_tariff_code: fromDatatype.GuidDataFieldInterface;
    tax_industry_code: fromDatatype.GuidDataFieldInterface;
    filing_status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_tax_txn_RowClass implements bl_fi_tax_txn_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    line_num: fromDatatype.NumericDatatypeInterface;
    tax_filing_date: fromDatatype.TimestampTzDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_line_guid: fromDatatype.GuidDataFieldInterface;
    enitity_type: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.TextDatatypeInterface;
    entity_comp_registration_num: fromDatatype.VarcharDatatypeInterface;
    entity_address: fromDatatype.TextDatatypeInterface;
    doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    doc_hdr_doc_type: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_num_comp: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_num_branch: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_amount_signum: fromDatatype.NumericDatatypeInterface;
    doc_hdr_amount_txn: fromDatatype.NumericDatatypeInterface; 
    doc_hdr_amount_net: fromDatatype.NumericDatatypeInterface;
    doc_hdr_amount_tax: fromDatatype.NumericDatatypeInterface;
    doc_hdr_amount_wht: fromDatatype.NumericDatatypeInterface;
    doc_hdr_tax_converted_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_hdr_tax_converted_by: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_self_bill_appr_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_hdr_self_bill_serial_num: fromDatatype.VarcharDatatypeInterface;
    doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    doc_line_guid: fromDatatype.GuidDataFieldInterface;
    doc_line_item_code: fromDatatype.VarcharDatatypeInterface;
    doc_line_item_desc: fromDatatype.GuidDataFieldInterface;
    doc_line_item_remarks: fromDatatype.TextDatatypeInterface;
    doc_line_item_qty: fromDatatype.NumericDatatypeInterface;
    doc_line_tax_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_line_tax_type: fromDatatype.VarcharDatatypeInterface;
    doc_line_tax_code: fromDatatype.VarcharDatatypeInterface;
    doc_line_tax_rate: fromDatatype.NumericDatatypeInterface;
    doc_line_tax_balance: fromDatatype.NumericDatatypeInterface;
    doc_line_wht_date: fromDatatype.TimestampTzDatatypeInterface;
    doc_line_wht_type: fromDatatype.VarcharDatatypeInterface;
    doc_line_wht_code: fromDatatype.VarcharDatatypeInterface;
    doc_line_wht_rate: fromDatatype.NumericDatatypeInterface;
    doc_line_wht_amount: fromDatatype.NumericDatatypeInterface;
    doc_line_wht_balance: fromDatatype.NumericDatatypeInterface;
    doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
    doc_line_amount_txn: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_net: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_tax: fromDatatype.NumericDatatypeInterface;
    doc_line_ccy_2: fromDatatype.VarcharDatatypeInterface;
    doc_line_amount_txn_2: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_net_2: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_tax_2: fromDatatype.NumericDatatypeInterface;
    doc_line_amount_wht_2: fromDatatype.NumericDatatypeInterface;
    doc_line_irr: fromDatatype.NumericDatatypeInterface;
    doc_line_permit_no: fromDatatype.VarcharDatatypeInterface;
    doc_line_major_industry_code: fromDatatype.VarcharDatatypeInterface;
    doc_line_property_json: fromDatatype.JsonDatatypeInterface;
    ext_property_json: fromDatatype.JsonDatatypeInterface;
    process_json: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    doc_hdr_client_doc: fromDatatype.VarcharDatatypeInterface;
    entity_tax_id: fromDatatype.VarcharDatatypeInterface;
    doc_event_guid: fromDatatype.GuidDataFieldInterface;
    doc_hdr_client_doc_type: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    filing_hdr_guid: fromDatatype.GuidDataFieldInterface;
    tax_tariff_code: fromDatatype.GuidDataFieldInterface;
    tax_industry_code: fromDatatype.GuidDataFieldInterface;
    filing_status: fromDatatype.VarcharDatatypeInterface;
}